module.exports = __webpack_public_path__ + "res-static/img/tgr-reverse.3610c8b8.svg";